/**
 *  Helper function to return the published or draft version of a document depending
 *  on if we are in preview mode. If in preview mode, Sanity returns both versions of
 *  the document instead of just one.
 */
export default function filterDataToSingleItemForPreview(data, preview) {
  if (!Array.isArray(data)) {
    return data;
  }

  if (data.length === 1) {
    return data[0];
  }

  if (preview) {
    return data.find((item) => item._id.startsWith(`drafts.`)) || data[0];
  }

  return data[0];
}
